import { useNavigate } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';
import Layout from '../components/ui/Layout';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const Settings = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuth();
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Layout>
      <div className='p-6 max-w-4xl mx-auto'>
        <div className='mb-6'>
          <h1 className='text-2xl font-bold text-foreground mb-2'>Settings</h1>
          <p className='text-muted-foreground'>
            Manage your application preferences and account settings
          </p>
        </div>

        {/* Appearance Settings */}
        {/* <div className='bg-card border border-border rounded-lg p-6 mb-6'>
          <h3 className='text-lg font-semibold text-foreground mb-4 flex items-center space-x-2'>
            <Icon name='Palette' size={20} />
            <span>Appearance</span>
          </h3>

          <div className='space-y-4'>
            <div className='flex items-center justify-between'>
              <div>
                <p className='font-medium text-foreground'>Theme</p>
                <p className='text-sm text-muted-foreground'>
                  Choose between light and dark mode
                </p>
              </div>
              <Button
                onClick={toggleTheme}
                variant='outline'
                className='flex items-center space-x-2'
              >
                <Icon name={isDark ? 'Sun' : 'Moon'} size={16} />
                <span>{isDark ? 'Light Mode' : 'Dark Mode'}</span>
              </Button>
            </div>

            <div className='flex items-center justify-between pt-4 border-t border-border'>
              <div>
                <p className='font-medium text-foreground'>Current Theme</p>
                <p className='text-sm text-muted-foreground capitalize'>
                  {theme} mode is currently active
                </p>
              </div>
              <div className='flex items-center space-x-2'>
                <div
                  className={`w-4 h-4 rounded-full ${isDark ? 'bg-gray-800' : 'bg-white'} border-2 border-border`}
                ></div>
                <span className='text-sm text-muted-foreground capitalize'>
                  {theme}
                </span>
              </div>
            </div>
          </div>
        </div> */}

        {/* Notification Settings */}
        {/* <div className="bg-card border border-border rounded-lg p-6 mb-6">
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center space-x-2">
            <Icon name="Bell" size={20} />
            <span>Notifications</span>
          </h3>
          
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium text-foreground">Email Notifications</p>
                <p className="text-sm text-muted-foreground">
                  Receive updates and alerts via email
                </p>
              </div>
              <Button
                onClick={() => handleNotificationChange('email')}
                variant={notifications?.email ? "default" : "outline"}
                size="sm"
              >
                {notifications?.email ? 'Enabled' : 'Disabled'}
              </Button>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-border">
              <div>
                <p className="font-medium text-foreground">Desktop Notifications</p>
                <p className="text-sm text-muted-foreground">
                  Show browser notifications for important updates
                </p>
              </div>
              <Button
                onClick={() => handleNotificationChange('desktop')}
                variant={notifications?.desktop ? "default" : "outline"}
                size="sm"
              >
                {notifications?.desktop ? 'Enabled' : 'Disabled'}
              </Button>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-border">
              <div>
                <p className="font-medium text-foreground">Mobile Push Notifications</p>
                <p className="text-sm text-muted-foreground">
                  Receive push notifications on mobile devices
                </p>
              </div>
              <Button
                onClick={() => handleNotificationChange('mobile')}
                variant={notifications?.mobile ? "default" : "outline"}
                size="sm"
              >
                {notifications?.mobile ? 'Enabled' : 'Disabled'}
              </Button>
            </div>
          </div>
        </div> */}

        {/* Account Settings */}
        <div className='bg-card border border-border rounded-lg p-6 mb-6'>
          <h3 className='text-lg font-semibold text-foreground mb-4 flex items-center space-x-2'>
            <Icon name='User' size={20} />
            <span>Account</span>
          </h3>

          <div className='space-y-4'>
            <div className='flex items-center justify-between'>   
              <div>
                <p className='font-medium text-foreground'>
                  Account Information
                </p>
                <p className='text-sm text-muted-foreground'>
                  {userProfile?.email || user?.email} •{' '}
                  {userProfile?.role || 'user'}
                </p>
              </div>
              <Button
                variant='outline'
                className='flex items-center space-x-2'
                onClick={() => navigate('/profile')}
              >
                <Icon name='Edit3' size={16} />
                <span>Edit Profile</span>
              </Button>
            </div>

            <div className='flex items-center justify-between pt-4 border-t border-border'>
              <div>
                <p className='font-medium text-foreground'>Password</p>
                <p className='text-sm text-muted-foreground'>
                  Last updated 30 days ago
                </p>
              </div>
              <Button
                variant='outline'
                className='flex items-center space-x-2'
                onClick={() => navigate('/profile?tab=password')}
              >
                <Icon name='Lock' size={16} />
                <span>Change Password</span>
              </Button>
            </div>
          </div>
        </div>

        {/* System Settings */}
        {/* <div className='bg-card border border-border rounded-lg p-6'>
          <h3 className='text-lg font-semibold text-foreground mb-4 flex items-center space-x-2'>
            <Icon name='Settings' size={20} />
            <span>System</span>
          </h3>

          <div className='space-y-4'>
            <div className='flex items-center justify-between'>
              <div>
                <p className='font-medium text-foreground'>Language</p>
                <p className='text-sm text-muted-foreground'>
                  Display language for the interface
                </p>
              </div>
              <select className='px-3 py-2 border border-border rounded-md bg-background text-foreground text-sm'>
                <option value='en'>English</option>
                <option value='es'>Español</option>
                <option value='fr'>Français</option>
              </select>
            </div>

            <div className='flex items-center justify-between pt-4 border-t border-border'>
              <div>
                <p className='font-medium text-foreground'>Time Zone</p>
                <p className='text-sm text-muted-foreground'>
                  Used for displaying dates and times
                </p>
              </div>
              <select className='px-3 py-2 border border-border rounded-md bg-background text-foreground text-sm'>
                <option value='utc'>UTC</option>
                <option value='est'>Eastern Time</option>
                <option value='pst'>Pacific Time</option>
                <option value='gmt'>GMT</option>
              </select>
            </div>
          </div>
        </div> */}
      </div>
    </Layout>
  );
};

export default Settings;
